import * as React from "react";
import {concatenate} from "services/string";
import Lottie from "lottie-react";
import NgageSpinnerAnimation from "../../assets/lottie-files/ngage-spinner.json";

enum Size { X_SMALL, SMALL, MEDIUM, LARGE, X_LARGE}

enum Color {BRAND, DARK}

type NgageSpinnerProps = {
    size?: Size
    color?: Color
};

const sizeClasses: Record<Size, string> = {
    [Size.X_SMALL]: 'w-8',
    [Size.SMALL]: 'w-10',
    [Size.MEDIUM]: 'w-12',
    [Size.LARGE]: 'w-14',
    [Size.X_LARGE]: 'w-16',
}

const colorClasses: Record<Color, string> = {
    [Color.BRAND]: 'text-brand',
    [Color.DARK]: 'text-gray-800',
}

const highlightlayerClass = 'oval-shape-highlight'

export function NgageSpinner({size = Size.MEDIUM, color = Color.DARK}: NgageSpinnerProps) {
    return (
      <Lottie
        className={concatenate(sizeClasses[size], colorClasses[color], `[&_.${highlightlayerClass}_path]:stroke-current`)}
        animationData={NgageSpinnerAnimation}
        loop={true}
      />
    );
}

NgageSpinner.sizes = Size
NgageSpinner.colors = Color